import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-expandable-content',
  standalone: true,
  imports: [CommonModule , MatIconModule],
  templateUrl: './expandable-content.component.html',
  styleUrls: ['./expandable-content.component.scss']
})
export class ExpandableContentComponent implements OnInit {
  isExpanded : boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  toggle():void {
    this.isExpanded = !this.isExpanded;
  }

}
